import React from 'react';
import Svg from '../Svg';

interface IArrivalHours {
  color?: string;
  size?: string;
  className?: string;
}

const ArrivalHours: React.FC<IArrivalHours> = ({ color = '#0B1215', size = '24px', className }) => (
  <Svg fill="none" size={size} path="" viewBox="0 0 24 24" className={className}>
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 6V12L16 14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default ArrivalHours;
